"use client";

import { useParams } from "next/navigation";
import { messages } from "@/lib/i18n";
import { useState, useEffect } from "react";
import { motion as _motion } from "framer-motion";
const motion: any = _motion;
import emailjs from "@emailjs/browser";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaEnvelope,
} from "react-icons/fa";

export default function ContactPage() {
  const { locale = "en" } = useParams<{ locale: "en" | "ar" | "fr" }>();
  const t = messages[locale] ?? messages.en;

  useEffect(() => {
    emailjs.init(process.env.NEXT_PUBLIC_EMAILJS_PUBLIC_KEY!);
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [state, setState] = useState<"idle" | "loading" | "success" | "error">(
    "idle"
  );

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setState("loading");

    try {
      await emailjs.send(
        process.env.NEXT_PUBLIC_EMAILJS_SERVICE_ID!,
        process.env.NEXT_PUBLIC_EMAILJS_TEMPLATE_ID!,
        {
          from_name: formData.name,
          reply_to: formData.email,
          message: formData.message,
        }
      );

      setFormData({ name: "", email: "", message: "" });
      setState("success");
    } catch (err) {
      console.error(err);
      setState("error");
    }
    console.log(process.env.NEXT_PUBLIC_EMAILJS_PUBLIC_KEY)
  };

  const c = t.contact;

  return (
    <section
      className="relative w-full min-h-screen flex flex-col items-center justify-center px-4 py-8
      bg-gradient-to-b from-black/90 via-yellow-900/10 to-black/80
    "
    >
      <div className="max-w-3xl w-full text-center mb-12 pt-32">
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
          {t.nav.contact}
        </h1>
        <p className="text-gray-300 text-lg">{t.footer.description}</p>
      </div>

      <div className="w-full max-w-3xl flex flex-col md:flex-row gap-8">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="flex-1 glass-panel neon-card rounded-xl p-8 flex flex-col gap-4 text-white"
        >
          <h2 className="text-xl font-semibold text-yellow-400">
            {t.footer.contactTitle}
          </h2>
          <div className="flex flex-col gap-2">
            <div className="flex justify-center items-center gap-6 mt-4 text-xl md:text-2xl">
              <a
                href="mailto:Smartline@smartline-sy.com"
                aria-label="Email SmartLine"
                title="Smartline@smartline-sy.com"
                className="text-[#EA4335] hover:opacity-80 transition"
              >
                <FaEnvelope />
              </a>
              <a
                href="https://www.facebook.com/share/17tdVbooPi/"
                className="text-[#1877F2] hover:opacity-80 transition"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://www.instagram.com/smartline.rw/"
                className="text-[#E4405F] hover:opacity-80 transition"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.linkedin.com/in/fadi-shalhoub-93a0803a3"
                className="text-[#0A66C2] hover:opacity-80 transition"
              >
                <FaLinkedinIn />
              </a>
            </div>
          </div>
        </motion.div>
        <motion.form
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="flex-1 glass-panel neon-card rounded-xl p-8 flex flex-col gap-4 text-white"
          onSubmit={handleSubmit}
        >
          <input
            type="text"
            name="name"
            placeholder={
            c.name
            }
            value={formData.name}
            onChange={handleChange}
            className="p-3 rounded glass-field placeholder-gray-300 text-white focus:outline-none"
            required
          />
          <input
            type="email"
            name="email"
            placeholder={
             c.email
            }
            value={formData.email}
            onChange={handleChange}
            className="p-3 rounded glass-field placeholder-gray-300 text-white focus:outline-none"
            required
          />
          <textarea
            name="message"
            rows={5}
            placeholder={
              c.message
            }
            value={formData.message}
            onChange={handleChange}
            className="p-3 rounded glass-field placeholder-gray-300 text-white focus:outline-none"
            required
          />

          <button
            type="submit"
            disabled={state === "loading"}
            className="bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600
              text-black font-semibold py-3 rounded-lg
              hover:from-yellow-300 hover:to-yellow-500 transition disabled:opacity-50"
          >
            {state === "loading" ? c.sending : c.send}
          </button>
          {state === "success" && (
            <p className="text-green-400 mt-2 text-center">{c.success}</p>
          )}
          {state === "error" && (
            <p className="text-red-400 mt-2 text-center">{c.error}</p>
          )}
        </motion.form>
      </div>
    </section>
  );
}
